export default "__VITE_ASSET__EBf1Tjxj__"